import React from 'react';
import { XIcon } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export const Modal = ({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) => {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={onClose} data-id="element-32">
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" data-id="element-33" />
      {/* Modal Content */}
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[85vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-34">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200" data-id="element-35">
          <h2 className="text-2xl font-bold text-black" data-id="element-36">{title}</h2>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full transition-colors" aria-label="Close modal" data-id="element-37">
            <XIcon size={24} className="text-gray-600" data-id="element-38" />
          </button>
        </div>
        {/* Scrollable Content */}
        <div className="p-6 overflow-y-auto max-h-[calc(85vh-140px)]" data-id="element-39">
          {children}
        </div>
        {/* Footer */}
        <div className="p-6 border-t border-gray-200" data-id="element-40">
          <button onClick={onClose} className="w-full px-6 py-3 bg-[#7A3CF3] text-white font-bold rounded-lg hover:bg-[#6B2FE3] transition-colors" data-id="element-41">
            Cerrar
          </button>
        </div>
      </div>
    </div>;
};